'use client'

import type { SearchModalTab } from '../../interfaces/modalTab.interface'

import styles from './SearchLineTabs.module.scss'

type SearchLineTabsProps = {
  tabs: readonly SearchModalTab[]
  activeTabId: string
  onTabChange: (id: string) => void
  ariaLabel?: string
}

export function SearchLineTabs({
  tabs,
  activeTabId,
  onTabChange,
  ariaLabel = 'Search categories',
}: SearchLineTabsProps) {
  return (
    <div className={styles.root} role="tablist" aria-label={ariaLabel}>
      {tabs.map((tab) => {
        const isActive = tab.id === activeTabId

        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            disabled={tab.disabled}
            className={isActive ? styles.tabActive : styles.tab}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.label}
          </button>
        )
      })}
    </div>
  )
}
